<template>
  <div class="flex flex-col flex-1 overflow-x-hidden">
    <MTab v-model="currentTab" position="left">
      <MTabPane v-for="tab in allTabs" :key="tab.key" :tab="tab.title">
        <HistoryListContainer
          :key="tab.key"
          :type="tab.key"
          :module-name="moduleName"
          :fetch-fn="fetchFn(tab.key)"
          :apply-component-type-filter="tab.key === 'change_log'"
          :is-snmp-asset="isSnmpAsset"
          :is-mobile-device-asset="isMobileDeviceAsset"
          v-bind="$attrs"
          :apply-discovery-method-filter="tab.key === 'scan_history'"
        />
      </MTabPane>
    </MTab>
  </div>
</template>

<script>
import { getAuditApi } from '@components/audit/api'
import HistoryListContainer from './history-list-container'
import {
  getScanHistoryApi,
  getChangeLogApi,
  getAssetMovementAndRepairHistoryApi,
  getWolHistoryApi,
  getgetAssetUtilizationHistoryApi,
} from '../../asset-api'
import {
  COMPUTER_PROPERTY_GROUP,
  MOBILE_DEVICE_PROPERTY_GROUP,
  CLOUD_DATABASE_COMPONENT,
  STORAGE_BUCKET_COMPONENT,
} from '../../helpers/asset'
export default {
  name: 'History',
  components: { HistoryListContainer },
  props: {
    moduleName: { type: String, required: true },
    assetConfigInfo: { type: Object, required: true },
    resource: { type: Object, required: true },
  },
  data() {
    return {
      currentTab: 'audit_trail',
    }
  },
  computed: {
    isSnmpAsset() {
      return this.assetConfigInfo.discoveryDeviceProtocol === 'snmp'
    },
    isMobileDeviceAsset() {
      return (this.assetConfigInfo.property || []).includes(
        'mobile_device_property_group'
      )
    },
    allowScanAndChangeLog() {
      return (
        (this.assetConfigInfo.property || []).indexOf(
          COMPUTER_PROPERTY_GROUP
        ) >= 0 ||
        (this.assetConfigInfo.component || []).indexOf(
          STORAGE_BUCKET_COMPONENT
        ) >= 0 ||
        (this.assetConfigInfo.component || []).indexOf(
          CLOUD_DATABASE_COMPONENT
        ) >= 0 ||
        (this.assetConfigInfo.property || []).indexOf(
          MOBILE_DEVICE_PROPERTY_GROUP
        ) >= 0 ||
        this.isSnmpAsset
      )
    },
    allTabs() {
      let tabs = [{ title: this.$tc('audit_trail'), key: 'audit_trail' }]
      if (this.allowScanAndChangeLog) {
        tabs = tabs.concat([
          { title: this.$tc('scan_history'), key: 'scan_history' },
          { title: this.$tc('change_log', 2), key: 'change_log' },
        ])
      }
      if (
        this.assetConfigInfo.discoveryDeviceProtocol === 'wmi' &&
        this.moduleName !== this.$constants.CMDB
      ) {
        tabs = tabs.concat([
          { title: this.$tc('wol_history'), key: 'wol_history' },
        ])
      }
      if (
        [
          this.$constants.ASSET_SOFTWARE,
          this.$constants.ASSET_CONSUMABLE,
          this.$constants.CMDB,
        ].indexOf(this.moduleName) === -1
      ) {
        tabs = tabs.concat([
          {
            title: `${this.$tc('movement')} ${this.$tc('history')}`,
            key: 'movement_history',
          },
          {
            title: `${this.$tc('repair')} ${this.$tc('history')}`,
            key: 'repair_history',
          },
        ])
      }
      if (
        !(
          this.resource &&
          (this.moduleName !== 'asset_hardware' ||
            (this.moduleName === 'asset_hardware' &&
              this.resource.origin !== 'agent' &&
              (!this.resource.agentActiveStatus ||
                (this.resource.agentActiveStatus &&
                  this.resource.agentActiveStatus === 'not_applicable'))))
        )
      ) {
        tabs = tabs.concat([
          {
            title: `${this.$tc('asset_utilization_history')}`,
            key: 'asset_utilization_history',
          },
        ])
      }
      return tabs
    },
  },
  methods: {
    fetchFn(currentTab) {
      if (currentTab === 'audit_trail') {
        return this.getAdit
      }
      if (currentTab === 'scan_history') {
        return this.getScanHistory
      }
      if (currentTab === 'change_log') {
        return this.getChangeLog
      }
      if (currentTab === 'movement_history') {
        return this.getMovementHistory
      }
      if (currentTab === 'repair_history') {
        return this.getRepairHistory
      }
      if (currentTab === 'wol_history') {
        return this.getWolHistory
      }
      if (currentTab === 'asset_utilization_history') {
        return this.getAssetUtilizationHistory
      }
    },
    getAdit(qual, moduleName, refId, limit, offset) {
      return getAuditApi(qual, moduleName, refId, limit, offset)
    },
    getScanHistory(qual, moduleName, refId, limit, offset) {
      return getScanHistoryApi(moduleName, qual, refId, limit, offset)
    },
    getChangeLog(qual, _, refId, limit, offset) {
      return getChangeLogApi(qual, refId, limit, offset)
    },
    getMovementHistory(qual, moduleName, refId, limit, offset) {
      return getAssetMovementAndRepairHistoryApi(
        qual,
        moduleName,
        refId,
        'history',
        limit,
        offset
      )
    },
    getRepairHistory(qual, moduleName, refId, limit, offset) {
      return getAssetMovementAndRepairHistoryApi(
        qual,
        moduleName,
        refId,
        'repair',
        limit,
        offset
      )
    },
    getWolHistory(qual, _, refId, limit, offset) {
      return getWolHistoryApi(qual, refId, limit, offset)
    },
    getAssetUtilizationHistory(qual, _, refId, limit, offset) {
      return getgetAssetUtilizationHistoryApi(qual, refId, limit, offset)
    },
  },
}
</script>
